import {apiCall} from "./apicall";

export async function fetchOffer(id){
    return await apiCall("/offers/"+id)
}

export async function fetchOffers(){
    return await apiCall("/offers")
}

export async function newOffer(LocationID){
    return await apiCall("/offers", {method:"POST"}, {LocationID});
}

export async function updateOffer(body){
    return await apiCall("/offers/"+body.OfferID, {method:"PUT"}, body);
}

export async function deleteOffer(id){
    return await apiCall("/offers/"+id, {method:"DELETE"});
}

export async function fetchCardsForOffer(OfferID){
    return await apiCall("/offers/"+OfferID+"/cards", {method:"GET"});
}

export async function addCardToOffer(OfferID, CardID){
    return await apiCall("/offers/"+OfferID+"/cards", {method:"POST"}, {CardID});
}

export async function removeCardFromOffer(OfferID, CardID){
    return await apiCall("/offers/"+OfferID+"/cards", {method: "DELETE"}, {CardID})
}
